<template>
  <div id="app">
    <router-view></router-view>

    <!-- 国内IP弹窗 -->
    <div class="ip-fail-mask" v-if="showFail">
      <div class="ip-fail-popup">
        <div class="ip-fail-content">
          <div class="ip-fail-message">
            经检测，您的IP地址是中国大陆，<br>
            原子链国际不向中国大陆用户提供任何服务。<br>
            欢迎访问原子链中国合规积分业务，<br>
            网址 <a class="ip-fail-url" href="https://atoshi.com.cn" target="_blank">{{erc20Address}}</a> 复制到浏览器打开
          </div>
          <div class="ip-fail-btn" @click="copyAddress">
            复制
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      showFail: false,
      erc20Address: "atoshi.com.cn",
    };
  },
  created() {
    this.judgeIp();
  },
  methods: {
    // 判断是否是国内IP
    judgeIp() {
      const baseUrl = process.env.NODE_ENV === 'production' 
        ? 'https://aggshop.juhaowu.cn' 
        : '';
      fetch(`${baseUrl}/intbaseapi/base/ipFrom?language=chinese`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          language: "chinese",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (res && res.code == 100 && res.data) {
            if (res.data.isChina) {
              this.showFail = true;
            }
          } else {
            this.showFail = true;
          }
        })
        .catch(() => {
          this.showFail = true;
        });
    },
    // 复制地址
    copyAddress() {
      const input = document.createElement("input");
      input.value = this.erc20Address;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      alert("复制成功");
    },
  },
};
</script>

<style lang="less">
/* 国内IP弹窗样式 */
.ip-fail-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ip-fail-popup {
  position: relative;
  background: #fff;
  border-radius: 16Px;
  padding: 50Px 60Px;
  width: 500Px;
  max-width: 90vw;
  box-sizing: border-box;
}
.ip-fail-content {
  text-align: center;
}
.ip-fail-message {
  font-size: 18Px;
  color: #333;
  line-height: 2;
  margin-bottom: 30Px;
}
.ip-fail-url {
  font-weight: bold;
  color: #00A0EA;
  text-decoration: underline !important;
  cursor: pointer;
}
.ip-fail-btn {
  display: inline-block;
  width: 160Px;
  height: 48Px;
  background: #00A0EA;
  color: #fff;
  border-radius: 24Px;
  line-height: 48Px;
  text-align: center;
  font-size: 18Px;
  cursor: pointer;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.8;
  }
}
@media (max-width: 768Px) {
  .ip-fail-popup {
    width: 85vw;
    max-width: 400Px;
    padding: 40Px 30Px;
  }
  .ip-fail-message {
    font-size: 15Px;
    margin-bottom: 24Px;
  }
  .ip-fail-btn {
    width: 140Px;
    height: 42Px;
    line-height: 42Px;
    font-size: 16Px;
    border-radius: 21Px;
  }
}
</style>
